import { DOCUMENT } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ApiService } from '../../services/api-service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {

  public selectedCountryCode;

  constructor(
    public translate: TranslateService,
    private apiService: ApiService) {
    this._initI18n();
  }

  /**
    * Init the list of languages and detect the browser lang
    */
  private _initI18n() {
    this.translate.addLangs(['en', 'fr', 'tn']);
    this.translate.setDefaultLang('tn');
    this.selectedCountryCode = this.apiService.get('local') || this.translate.getBrowserLang();
    this.translate.use(this.selectedCountryCode.match(/en|fr|tn/) ? this.selectedCountryCode : 'tn');
    this.apiService.addOnlyOneString('local', this.selectedCountryCode);
  }

  /**
   * Switch the language
   */
  public switchLang(lang: string) {
    this.translate.use(lang);
    this.selectedCountryCode = lang;
    this.apiService.addOnlyOneString('local', this.selectedCountryCode);
  }

}
